<template>
  <div>
    <b-nav-item
      @click="navigateToMySchedule"
      class="position-absolute schedule-mobile"
      style="right: 15%; top: 1%; z-index: 100"
    >
      <i class="material-icons" style="font-size: 27px">calendar_today</i>
      <span
        class="my-count text-center position-absolute"
        style="width: 22px; height: 22px; line-height: inherit; margin-top: 0"
        >{{ $store.state.count }}</span
      >
    </b-nav-item>
    <b-navbar toggleable="lg" class="top p-0 position-relative mr-0 mr-sm-3">
      <!-- <a href="https://www.google.com/calendar/render?action=TEMPLATE&text=%C3%98redev&dates=20201104T070000Z%2F20201106T153000Z&details=For%20details%2C%20see%20https%3A%2F%2Fwww.oredev.org.%0A&location=Malm%C3%B6M%C3%A4ssan%20Exhibition%20%26%20Congress%20Center&sf=true&output=xml" target="_blank" class="next">
    Save the date: <span class="date">November 4–6, 2020</span>
      </a>-->
      <b-navbar-brand class="p-3">
        <router-link to="/">
          <b-img
            style="width: 42px; margin-top: -10px"
            src="https://res.cloudinary.com/oredev/image/upload/v1712152990/2024/logo12.png"
          ></b-img>
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="p-3">
        <span
          class="material-symbols-outlined"
          style="font-size: 2rem !important"
        >
          menu
        </span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="text-center background">
        <div class="d-lg-none mt-5 mb-2">
          <h1 class="theme text-color-dark">Wondering when?</h1>
          <p class="text-uppercase text-color-dark">
            6–8 Nov 2024 - Malmö, Sweden
          </p>
        </div>
        <b-navbar-nav class="ml-auto">
          <b-nav-item class="b-nav-item" to="/tickets">Tickets</b-nav-item>
          <b-nav-item
            :to="{
              path: '/line-up',
              query: { tags: $route.query.tags, day: $route.query.day },
            }"
            >Line-up</b-nav-item
          >
          <b-nav-item to="/program">Program</b-nav-item>
          <b-nav-item
            hidden
            :to="{
              path: '/sessions',
              query: { tags: $route.query.tags, day: $route.query.day },
            }"
            >Sessions</b-nav-item
          >

          <b-nav-item class="b-nav-item" to="/oredev+">Øredev+</b-nav-item>
          <b-nav-item to="/info" class="active">Info</b-nav-item>
          <!--a class="nav-item nav-link text-dark show-search-button nav-link" href="#search" data-toggle="collapse" aria-expanded="false" aria-controls="search"><i class="material-icons mobile-search">search</i></a-->
          <b-nav-item
            @click="navigateToMySchedule"
            style="margin-top: -8px"
            class="position-relative schedule-dekstop"
            id="my-schedule"
          >
            <i class="material-icons">calendar_today</i>
            <span class="my-count text-center position-absolute">{{
              $store.state.count
            }}</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-tooltip target="my-schedule" placement="bottom" trigger="hover"
      >My schedule</b-tooltip
    >
  </div>
</template>

<script>
export default {
  name: "top",
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },

  data() {
    return {
      scrollPosition: "0",
      active: false,
      windowWidth: window.innerWidth,
    };
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (window.scrollY > 200) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    navigateToMySchedule() {
      const id =
        this.$route.params.id ||
        localStorage.getItem("myscheduleid") ||
        localStorage.getItem("revertmyschedule");
      if (id) {
        // Navigate to MySchedule with ID
        this.$router.push({
          name: "MySchedule-id",
          params: { id },
          query: { nochange: this.$route.query.nochange },
        });
      } else {
        // Navigate to MySchedule without ID
        this.$router.push({ name: "MySchedule" });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },

  computed: {
    isMobile() {
      if (this.windowWidth <= 576) {
        return true;
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
/* .background {
  background: url(https://res.cloudinary.com/oredev/image/upload/f_autoq_65/v1556784443/2019/html/background-start-2.jpg);
}
 */
.top {
  z-index: 99;
}

.material-icons {
  font-size: 35px;
}

h1.theme {
  font-size: 1.7rem !important;
}

.my-count {
  top: 10px;
  position: absolute;
  border: 1px solid $orange;
  border-radius: 50%;
  margin: -6px 0 0 0;
  right: 15px;
  width: 30px;
  height: 30px;
  line-height: 1.6rem;
  font-size: 1.1rem;
  font-weight: normal;
  background-color: $orange !important;
  color: #fff;
  @media (max-width: 992px) {
    top: 0;
    margin-left: -15px;
    right: auto;
    left: auto;
  }
}

nav {
  opacity: 1;
  @media (max-width: 991px) {
    opacity: 1;
    border-bottom: 1px solid #ddd;
  }
}

nav {
  // background: #fff;
  opacity: 1;
  @media (max-width: 991px) {
    opacity: 1;
    border-bottom: 1px solid #ddd;
  }
}

.schedule-dekstop {
  display: block;
  @media (max-width: 991px) {
    display: none;
  }
}
.schedule-mobile {
  display: none;
  @media (max-width: 991px) {
    display: block;
  }
}

a.nav-link {
  text-transform: uppercase;
  font-weight: 600;
  color: $yellow !important;
  text-decoration: none !important;
  //margin-left: 30px;
  font-size: 18px;
  text-align: center;
}
a.nav-link:hover {
  color: $text-dark !important;
}

.navbar-brand.router-link-exact-active {
  fill: $pink;
}
a.router-link-exact-active {
  fill: $yellow !important;
}
a.router-link-active {
  text-decoration: underline !important;
  color: $text-dark !important;
}

.navbar-light .navbar-toggler {
  border: 0 !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue